<template>
  <div v-if="isExternal" :style="styleExternalIcon" class="svg-external-icon svg-icon" :class="className"></div>
  <svg v-else class="svg-icon" :class="className" :viewBox="fit ? '0 0 1024 1024' : undefined" aria-hidden="true">
    <use ref="shape" :xlink:href="iconName" :width="fit ? 1024 : undefined" :height="fit ? 1024 : undefined" :transform="shapeTransform"></use>
  </svg>
</template>
<script lang="ts" setup>
import { isExternal as external } from '@/utils/validate'
import { computed, ref, watch, nextTick, onMounted } from 'vue'
const props = defineProps({
  icon: {
    type: String,
    required: true
  },
  fit: { type: Boolean, default: false },
  className: {
    type: String,
    default: ''
  }
})
const isExternal = computed(() => external(props.icon))
const styleExternalIcon = computed(() => ({
  mask: `url(${props.icon}) no-repeat 50% 50%`,
  '-webkit-mask': `url(${props.icon})`
}))
const iconName = computed(() => `#icon-${props.icon}`)
const shape = ref<SVGGraphicsElement>()
const shapeTransform = ref<string>()
// 折叠导航按图形实际边界统一大小，其他位置保持原有图标表现。
const fitShape = async () => {
  shapeTransform.value = undefined
  await nextTick()
  if (!props.fit || !shape.value) return
  const box = shape.value.getBBox()
  const edge = Math.max(box.width, box.height)
  if (edge <= 0) return
  const scale = 1024 / edge
  shapeTransform.value = `translate(${512 - (box.x + box.width / 2) * scale} ${512 - (box.y + box.height / 2) * scale}) scale(${scale})`
}
onMounted(fitShape)
watch(() => [props.icon, props.fit], fitShape)
</script>
<style lang="scss" scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.svg-external-icon {
  background-color: currentColor;
  mask-size: cover !important;
  display: inline-block;
}
</style>
